import React, { Suspense, useContext } from 'react';
import { Await, useLoaderData } from 'react-router-dom';
import NoChatroom from './NoChatroom';
import ActivityTemplateCarousel from '../template-carousel/ActivityTemplateCarousel';
import ChatroomList from './ChatroomList';
import { Data } from '../../loaders/chatroomListLayoutLoader';
import { CustomerProfile } from '../../models/customerProfile';
import LIFFUserContext from '../../contexts/LIFFUserContext';
import Spinner from '../../share/Spinner';
import { useTranslation } from 'react-i18next';

export default function ChatroomListLayout() {
  const [t] = useTranslation(['chatroom', 'admin']);
  document.title = t('activity_group', '活動工作群');
  const customProfile = useContext(LIFFUserContext) as CustomerProfile;
  const deferredData = useLoaderData() as { data: Data };

  const wrapFunc = (data: Data) => {
    const [chatrooms, taggedTemplateCollections] = data;
    const noChatroom = chatrooms.length === 0;
    const isABO = customProfile?.isABO;
    const element = noChatroom ? (
      <NoChatroom isABO={isABO} />
    ) : (
      <ChatroomList rooms={chatrooms} />
    );
    const backgroundColor = noChatroom ? 'bg-white' : 'bg-gray-100';

    return (
      <div
        className={`flex flex-col items-center min-h-screen ${backgroundColor}`}
      >
        {element}
        <ActivityTemplateCarousel
          taggedTemplateCollections={taggedTemplateCollections}
        />
      </div>
    );
  };

  return (
    <Suspense fallback={<Spinner />}>
      <Await resolve={deferredData.data}>{wrapFunc}</Await>
    </Suspense>
  );
}
